import { render, staticRenderFns } from "./resetpwd.vue?vue&type=template&id=0b9ea6d5&scoped=true"
import script from "./resetpwd.vue?vue&type=script&lang=js"
export * from "./resetpwd.vue?vue&type=script&lang=js"
import style0 from "./resetpwd.vue?vue&type=style&index=0&id=0b9ea6d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ea6d5",
  null
  
)

export default component.exports